import FeaturedTeams from "./FeaturedTeams";
export default FeaturedTeams;